import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useParams, useNavigate } from "react-router-dom";
import { baseUrl, userLocation, ipAddress, userName } from "../Univ.js";

function EditProduct() {

  const { id } = useParams();


  const [data, setData] = useState({
    name: "",
    code: "",
    unit: "",
    description: ""
  });

  useEffect(() => {
    fetchProduct();
  }, []);

  const fetchProduct = () => {
    axios.get(baseUrl + "products/" + id + "/")
      .then(res => {
        setData(res.data);
      });
  };

  const inputHandler = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value
    });
  };

  const formSubmit = () => {

    const _formData = new FormData();
    _formData.append("name", data.name);
    _formData.append("code", data.code);
    _formData.append("unit", data.unit);
    _formData.append("description", data.description);
    _formData.append("status", "1");
    _formData.append("addedby", userName);
    _formData.append("ip_add", ipAddress);
    _formData.append("location", userLocation);

    axios.put(baseUrl + "products/" + id + "/", _formData, {
      headers: { "Content-Type": "multipart/form-data" }
    })
    .then(response => {
      if (response.status === 200) {
        Swal.fire({
          title: "Product Updated",
          icon: "success",
          timer: 2000,
          showConfirmButton: false
        });

        setTimeout(() => {
            window.location.href = ('/products/');
        }, 2000);
      }
    })
    .catch(() => {
      Swal.fire("Error", "Update failed", "error");
    });
  };

  return (
    <div className="container mt-4">
      <div className="card p-4">
        <h4>Edit Product</h4>

        <input
          type="text"
          className="form-control mt-3"
          name="name"
          value={data.name}
          onChange={inputHandler}
        />

        <input
          type="text"
          className="form-control mt-3"
          name="code"
          value={data.code}
          onChange={inputHandler}
        />

        <input
          type="text"
          className="form-control mt-3"
          name="unit"
          value={data.unit}
          onChange={inputHandler}
        />

        <textarea
          className="form-control mt-3"
          name="description"
          value={data.description}
          onChange={inputHandler}
        />

        <button
          className="btn btn-primary mt-3"
          onClick={formSubmit}
        >
          Update
        </button>

      </div>
    </div>
  );
}

export default EditProduct;
